<div class="container">
    <div class="mt-0 p-5 row bg-light border-top border-dark">
        <div class="col-12 col-md-6">
            <form [formGroup]="forgotPasswordForm" autocomplete="off">
                <div class="mb-1 row">
                    <div class="col-12 col-md-4">
                        <app-label controlName="email" class="col-form-label">{{ 'forgot_password.email' | translate }}</app-label>
                    </div>
                    <div class="col-12 col-md-8">
                        <input type="text" id="email" formControlName="email" class="form-control" />
                        <app-field-error-message controlName="email"></app-field-error-message>
                    </div>
                </div>
                <br />
                <br />
                <div class="my-3">
                    <button type="submit" [appClickWait]="forgotPassword" class="btn btn-primary float-end">
                        {{ 'common.submit' | translate }}
                    </button>
                </div>
            </form>
        </div>
        <div class="ms-4 p-2">
            <app-html-viewer [type]="type"></app-html-viewer>
        </div>
    </div>
</div>
